import React from "react";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurClinicalEssence() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="nossa-essência-clínica" ref={sectionRef} className="relative w-full py-20 lg:py-32 overflow-hidden bg-linear-to-br from-background via-background to-accent/50">
      {}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-linear-to-l from-white/40 to-transparent pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div className={`lg:col-span-5 relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="relative rounded-[var(--radius)] overflow-hidden shadow-xl aspect-[3/4] lg:aspect-[4/5]">
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10 pointer-events-none" />
              <img src="https://dilsaudecapilar.com.br/wp-content/uploads/2026/03/dilma.png" alt="Dra. Carla Almeida em atendimento clínico" className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 bg-card p-6 rounded-[var(--radius)] shadow-lg max-w-[200px] hidden md:block border border-border/50">
              <p className="text-primary font-serif text-4xl font-bold mb-1">10+</p>
              <p className="text-muted-foreground text-xs uppercase tracking-wider font-medium">
                Anos de Experiência em Tricologia
              </p>
            </div>
          </div>

          {}
          <div className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="mb-8">
              <span className="inline-block py-1 px-3 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-widest uppercase mb-4">
                Nossa Essência
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-foreground leading-tight">
                Ciência Capilar com <span className="italic text-primary">Alma Feminina</span>
              </h2>
            </div>

            <div className="relative">
              <Quote className="absolute -top-4 -left-4 w-12 h-12 text-accent/40 -z-10 rotate-180" />
              <blockquote className="text-lg md:text-xl text-muted-foreground leading-relaxed font-light mb-8 relative z-10">
                "Na Dil Saúde Capilar, acreditamos que cada fio conta uma história. Nossa missão é unir a precisão diagnóstica da tricologia avançada ao acolhimento que toda mulher merece. Não tratamos apenas patologias do couro cabeludo; restauramos a autoestima e o bem-estar através de protocolos baseados em evidências e um olhar profundamente humano."
              </blockquote>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 border-t border-border pt-8 mt-4">
              <div className="flex flex-col">
                <h3 className="text-xl font-serif font-semibold text-foreground">Dra. Dilma Betmann</h3>
                <p className="text-sm text-muted-foreground uppercase tracking-wide">
                  Especialista em Tricologia & Fundadora
                </p>
              </div>
              
              <div className="hidden sm:block h-12 w-px bg-border mx-2" />
              
              <div className="flex gap-4">
                 <Button asChild variant="outline" className="rounded-full border-primary/30 text-primary hover:bg-primary hover:text-white transition-colors">
                    <Link to="/ClinicPage">
                      Conheça a Clínica
                    </Link>
                 </Button>
                 <Button asChild className="rounded-full shadow-lg shadow-primary/20">
                    <Link to="/SchedulingPage">
                      Agendar Consulta
                    </Link>
                 </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}